"use client";

import { setBaseURL } from "@kaplan-labs/up-auth-api-client";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { pageview } from "@up/analytics";
import { CartProvider } from "@up/checkout";
import { SetupModalTriggers } from "@up/lead-capture";

import { FrontendInit } from "./frontend-init";

import type { ReactNode } from "react";

setBaseURL(process.env["NEXT_PUBLIC_HALL_OF_RECORDS_URI"] as string);

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const pathname = usePathname();

  useEffect(() => {
    pageview(pathname);
  }, [pathname]);

  return (
    <>
      <FrontendInit />
      <SetupModalTriggers>
        <CartProvider
          baseURL={process.env["NEXT_PUBLIC_HALL_OF_RECORDS_URI"] as string}
          navigateToPath={(path) => {
            window.location.href = path;
          }}
        >
          {children}
        </CartProvider>
      </SetupModalTriggers>
      <div id="cart-portal" />
      <div id="signin-portal" />
      <div id="cohort-switch-portal" />
    </>
  );
}
